var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('OrderSearch',{attrs:{"view-type":_vm.vt}}),_c('OrderList',{attrs:{"status":_vm.status,"view-type":_vm.vt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }